<template>
  <div v-loading="showFlag">
    <t-card>
      <!-- 個人売上詳細レポート画面 -->
      <div :style="{ height: basicHeight + 'px' }">
        <t-form
          label-position="right"
          :label-width="$t('widgetSize.ORDER.SEARCH_LABEL_WIDTH')"
        >
          <!-- 担当者名 と 報告出力ボタン -->
          <t-row>
            <t-col :span="5" class="col_common_left">
              <t-form-item
                :label="$t('resource.NUMBER.CONTACTER')"
                class="marginBottom"
              >
                <t-input v-model="userName" class="commonDialog" disabled>
                </t-input>
              </t-form-item>
            </t-col>
            <t-col :span="19" class="right">
              <!-- 報告出力ボタン -->
              <t-button
                round
                type="primary"
                ref="outPut"
                class="button_common_search marginRight"
                @click="outPutClick()"
              >
                <i class="el-icon-download"></i
                >{{ $t("resource.REPORT.REPORT_OUT") }}
              </t-button>
            </t-col>
          </t-row>
        </t-form>
      </div>

      <div>
        <t-table
          :data="annualSalesDetailByUserList"
          tooltip-effect="dark"
          style="width: 100%"
          header-cell-class-name="bg-default"
          :height="detailHeight"
          :span-method="handleSpanMethod"
          highlight-current-row
          border
        >
          <t-table-column
            v-if="periodMonthList.length"
            fixed
            width="50"
            prop="no"
            class-name="cell_txt_center"
            :label="$t('resource.ANNUAL_SALES_BY_USER.NO')"
          ></t-table-column>
          <t-table-column
            v-if="periodMonthList.length"
            fixed
            width="100"
            prop="ucNo"
            class-name="cell_txt_center"
            :label="$t('resource.ANNUAL_SALES_BY_USER.UC_NO')"
          ></t-table-column>
          <t-table-column
            v-if="periodMonthList.length"
            fixed
            width="150"
            prop="cusAbbreviation"
            class-name="cell_txt_left"
            :label="$t('resource.ANNUAL_SALES_BY_USER.CUS_ABBREVIATION')"
          ></t-table-column>
          <t-table-column
            v-if="periodMonthList.length"
            fixed
            width="100"
            prop="kbn"
            class-name="cell_txt_center"
            :label="$t('resource.ANNUAL_SALES_BY_USER.KBN')"
          ></t-table-column>

          <t-table-column
            v-for="(column, index) in periodMonthList"
            :key="index"
            :label="column.title"
            min-width="120"
            class-name="cell_txt_right"
            ><template #default="scope">
              <!-- UPD 2026/04/01 Wjx 課題_顧客からの改善したい点への対応 start↓ -->
              <!-- 加工単価(CNY)の入力可能な最大値の変更 -->
              <!-- <t-input
                class="cell_input_custom"
                :controls="false"
                :maxlength="9"
                :disabled="disabledCheck(scope.row)"
                v-model="scope.row.dicAmount['amount' + (index + 1)]"
                @blur="changeCellData(scope.$index, index)"
                @focus="
                  changeCellDataToNumber(scope.row, 'amount' + (index + 1))
                "
                @input="
                  scope.row.dicAmount['amount' + (index + 1)] =
                    scope.row.dicAmount['amount' + (index + 1)].replace(
                      /[^\d]/g,
                      ''
                    )
                "
                :ref="`input-${scope.$index}-${index}`"
                @keyup.native.enter="focusNextInput(scope.$index, index)"
              ></t-input> -->
              <t-input
                class="cell_input_custom"
                :controls="false"
                :maxlength="12"
                :disabled="disabledCheck(scope.row)"
                v-model="scope.row.dicAmount['amount' + (index + 1)]"
                @blur="changeCellData(scope.$index, index)"
                @focus="
                  changeCellDataToNumber(scope.row, 'amount' + (index + 1))
                "
                @input="
                  scope.row.dicAmount['amount' + (index + 1)] =
                    scope.row.dicAmount['amount' + (index + 1)].replace(
                      /[^\d]/g,
                      ''
                    )
                "
                :ref="`input-${scope.$index}-${index}`"
                @keyup.native.enter="focusNextInput(scope.$index, index)"
              ></t-input>
              <!-- UPD 2026/04/01 Wjx 課題_顧客からの改善したい点への対応 end↑ -->
            </template>
          </t-table-column>

          <t-table-column
            v-if="periodMonthList.length"
            width="150"
            prop="annualTotalAmount"
            class-name="cell_txt_right"
            :label="$t('resource.ANNUAL_SALES_BY_USER.ANNUAL_TOTAL_AMOUNT')"
          ></t-table-column>
        </t-table>
      </div>
      <!-- 合計 -->
      <div :style="{ height: bottomHeight + 'px' }">
        <t-row>
          <t-col :span="24" class="right">
            <!-- 確定ボタン -->
            <t-button
              round
              type="warning"
              class="dialogButton_confirm_120_40"
              ref="confirmBtn"
              @click="confirmClick()"
            >
              <i class="el-icon-check"></i>
              {{ $t("resource.sys.sure") }}
            </t-button>
          </t-col>
        </t-row>
      </div>
    </t-card>
  </div>
</template>
<script>
import { httpApi } from "@/api/api";
import { getUserInfo } from "@/auth";
import { t } from "@/locales";
import {
  SearchAnnualSalesDetailByUserData,
  UpdateAnnualSalesDetailByUserData,
} from "@/services/annualSalesByUserReport";
import { outputExcelToZip } from "@/services/common";
import {
  formatCurrencyToNumber,
  formatStringToCurrency,
  getDialogContentHeight,
} from "@/utils/comFunction";
import { DIALOG_LINE_HEIGHT } from "@/utils/const";
import { Message } from "@tellus/component";

export default {
  data() {
    return {
      //基本情報のheight
      basicHeight: DIALOG_LINE_HEIGHT * 1,
      //明細情報のheight
      detailHeight: getDialogContentHeight(
        window.innerHeight,
        DIALOG_LINE_HEIGHT * 1,
        DIALOG_LINE_HEIGHT * 1,
        0
      ),
      //確定のheight
      bottomHeight: DIALOG_LINE_HEIGHT * 1,

      //期間月度
      periodMonthList: [],
      //件数データ
      annualSalesDetailByUserList: [],

      showFlag: false,
    };
  },

  props: {
    //担当者コード
    userId: {
      Type: String,
    },
    //担当者名
    userName: {
      Type: String,
    },
    //月度差
    monthsDiff: {
      Type: Number,
    },
    //検索開始年月
    searchStartYearMonth: {
      Type: String,
    },
    //検索終了年月
    searchEndYearMonth: {
      Type: String,
    },
  },

  mounted() {
    this.init();
    //テーブルの高さを監視する
    window.addEventListener("resize", this.handleResize);
  },

  methods: {
    // 初期化
    init() {
      this.showFlag = true;
      //検索
      this.searchClick();

      this.handleResize();
    },

    //テーブルの高さを設定する
    handleResize() {
      this.detailHeight = getDialogContentHeight(
        window.innerHeight,
        DIALOG_LINE_HEIGHT * 1,
        DIALOG_LINE_HEIGHT * 1,
        0
      );
    },

    // 検索
    searchClick() {
      SearchAnnualSalesDetailByUserData({
        searchStartYearMonth: this.searchStartYearMonth,
        searchEndYearMonth: this.searchEndYearMonth,
        userId: this.userId,
      })
        .then((res) => {
          //期間月度
          this.periodMonthList.length = 0;
          var searchStartYearMonthTmp = JSON.stringify(
            this.searchStartYearMonth
          );
          let month = parseInt(searchStartYearMonthTmp.split("/")?.[1]);

          for (let i = 0; i <= this.monthsDiff; i++) {
            if (parseInt(month) + i <= 12) {
              this.periodMonthList.push({
                title:
                  parseInt(month) + i + t("resource.CUS_M_ORDER_AMOUNT.MONTH"),
              });
            } else {
              this.periodMonthList.push({
                title:
                  parseInt(month) +
                  i -
                  12 +
                  t("resource.CUS_M_ORDER_AMOUNT.MONTH"),
              });
            }
          }
          //データ
          this.annualSalesDetailByUserList = res.annualSalesDetailByUserList;
          //データの処理
          this.dataProcess();
          this.getBgSpanArr(this.annualSalesDetailByUserList);
          this.showFlag = false;
        })
        .catch((err) => {
          this.showFlag = false;
          Message.showError(
            t("message.CUS_M_ORDER_AMOUNT.SEARCH_FAILURE"),
            null
          );
        });
    },

    //データの処理
    dataProcess() {
      this.annualSalesDetailByUserList.map((item) => {
        if (item.no.includes(",")) {
          // item.no = item.no.split(",").join("\n");
          item.no = item.no.split(",").join("「") + "」";
        }
        return item;
      });
    },

    changeCellDataToNumber(curRow, columnName) {
      curRow.dicAmount[columnName] = formatCurrencyToNumber(
        curRow.dicAmount[columnName]
      );
    },

    //データの変更
    changeCellData(rowNum, colNum) {
      this.$nextTick(() => {
        let colName = "amount" + (colNum + 1);
        //月度列
        this.annualSalesDetailByUserList[rowNum].dicAmount[colName] =
          formatStringToCurrency(
            formatCurrencyToNumber(
              this.annualSalesDetailByUserList[rowNum].dicAmount[colName]
            )
          );
        this.totalCalculation(rowNum, colNum);
      });
    },

    //小計の計算
    totalCalculation(rowNum, colNum) {
      //一覧データ
      let dtTable = this.annualSalesDetailByUserList;
      //行の年計
      let sum = 0;
      for (let colIndex = 0; colIndex <= this.monthsDiff; colIndex++) {
        //月度列
        let colName = "amount" + (colIndex + 1);
        sum += formatCurrencyToNumber(dtTable[rowNum].dicAmount[colName]);
      }
      dtTable[rowNum].annualTotalAmount = formatStringToCurrency(
        formatCurrencyToNumber(sum)
      );
      //集計行の目標合計
      let targetSum = 0;
      for (rowNum; rowNum < dtTable.length; rowNum += 5) {
        //月度列
        let colName = "amount" + (colNum + 1);
        targetSum += formatCurrencyToNumber(dtTable[rowNum].dicAmount[colName]);
      }
      //売上目標
      if (rowNum % 5 == 0) {
        dtTable[0].dicAmount["amount" + (colNum + 1)] = formatStringToCurrency(
          formatCurrencyToNumber(targetSum)
        );
      }
      //粗利目標
      else if (rowNum % 5 == 2) {
        dtTable[2].dicAmount["amount" + (colNum + 1)] = formatStringToCurrency(
          formatCurrencyToNumber(targetSum)
        );
      }
    },

    //入力ボックスをクリックできるかどうか
    disabledCheck(row) {
      //非集計データの場合
      if (!isNaN(Number(row.no))) {
        //「売上目標」または「粗利目標」の場合
        if (row.kbn.includes(t("resource.ANNUAL_SALES_BY_USER.TARGET"))) {
          return false;
        }
      }
      return true;
    },

    //Enter処理
    focusNextInput(index, column) {
      index = index + 1;

      if (index > this.annualSalesDetailByUserList.length - 1) {
        for (var i = 5; i < this.annualSalesDetailByUserList.length; i++) {
          var tmpIndex = this.$refs[`input-${i}-${column}`].length - 1;
          if (
            this.$refs[`input-${i}-${column}`] !== undefined &&
            !this.$refs[`input-${i}-${column}`][tmpIndex].disabled
          ) {
            this.$refs[`input-${i}-${column}`][tmpIndex].focus();

            break;
          }
        }
      } else {
        for (var i = index; i < this.annualSalesDetailByUserList.length; i++) {
          var tmpIndex = this.$refs[`input-${i}-${column}`].length - 1;
          if (
            this.$refs[`input-${i}-${column}`] !== undefined &&
            !this.$refs[`input-${i}-${column}`][tmpIndex].disabled
          ) {
            this.$refs[`input-${i}-${column}`][tmpIndex].focus();

            break;
          }
        }
        //下に入力ボックスがない場合は、最初から
        if (i == this.annualSalesDetailByUserList.length) {
          this.focusNextInput(-1, column);
        }
      }
    },

    //確定ボタン
    confirmClick() {
      var tableDatas = [];
      //非集計行から開始
      for (
        let rowNum = 0;
        rowNum < this.annualSalesDetailByUserList.length;
        rowNum++
      ) {
        var obj = {};
        for (let colNum = 0; colNum < this.periodMonthList.length; colNum++) {
          let colName = "amount" + (colNum + 1);
          var numVal;
          if (rowNum % 5 != 4) {
            //月度列
            const moneyValue =
              this.annualSalesDetailByUserList[rowNum].dicAmount[colName];
            //値
            numVal = formatCurrencyToNumber(moneyValue);
          } else {
            numVal =
              this.annualSalesDetailByUserList[rowNum].dicAmount[colName];
          }
          obj[colName] = numVal;
        }
        tableDatas.push(obj);
      }

      UpdateAnnualSalesDetailByUserData({
        tableDatas: tableDatas,
        annualSalesDetailByUserList: this.annualSalesDetailByUserList,
        searchStartYearMonth: this.searchStartYearMonth,
        searchEndYearMonth: this.searchEndYearMonth,
        updateUser: getUserInfo().UserId,
        userId: this.userId,
      })
        .then((res) => {
          Message.showSuccess(t("message.COMMON.UPDATE_SUCCESS"));
        })
        .catch((err) => {
          Message.showError(t("message.COMMON.UPDATE_FAILURE"), null);
        })
        .finally(() => {
          this.showFlag = false;
          this.searchClick();
        });
    },

    // 一覧表行目結合
    handleSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        if (columnIndex === 0) {
          return {
            rowspan: 5,
            colspan: 3,
          };
        } else if (columnIndex === 1 || columnIndex === 2) {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      } else {
        if (columnIndex === 0) {
          return {
            rowspan: row.rowspan,
            colspan: 1,
          };
        }
        if (columnIndex === 1) {
          return {
            rowspan: row.rowspansecond,
            colspan: 1,
          };
        }
        if (columnIndex === 2) {
          return {
            rowspan: row.rowspanthird,
            colspan: 1,
          };
        }
      }
    },

    outPutClick() {
      this.$refs.outPut.$el.blur();

      this.showFlag = true;

      outputExcelToZip(httpApi.OutAnnualSalesDetailByUserDataByExcel, {
        searchStartYearMonth: this.searchStartYearMonth,
        searchEndYearMonth: this.searchEndYearMonth,
        titleDtos: this.periodMonthList,
        userId: this.userId,
      })
        .then((res) => {
          //検索
          this.searchClick();
        })
        .finally(() => {
          this.showFlag = false;
        });
    },

    //一覧表行目結合データの取得
    getBgSpanArr(list) {
      let firstIndex = 0;
      let firstItem = "";
      let secondIndex = 0;
      let secondItem = "";
      let thirdIndex = 0;
      let thirdItem = "";

      //
      for (let i = 0; i < list.length; i++) {
        list[i].rowspan = 1;
        list[i].rowspansecond = 1;
        list[i].rowspanthird = 1;

        //通№の比較
        if (list[i].no == firstItem) {
          list[firstIndex].rowspan++;
          list[i].rowspan = 0;
        } else {
          firstIndex = i;
          firstItem = list[i].no;
        }

        //№の比較
        if (list[i].ucNo == secondItem) {
          list[secondIndex].rowspansecond++;
          list[i].rowspansecond = 0;
        } else {
          secondIndex = i;
          secondItem = list[i].ucNo;
        }
        //企業名の比較
        if (list[i].cusAbbreviation == thirdItem) {
          list[thirdIndex].rowspanthird++;
          list[i].rowspanthird = 0;
        } else {
          thirdIndex = i;
          thirdItem = list[i].cusAbbreviation;
        }
      }
      this.annualSalesDetailByUserList = list;
    },
  },
};
</script>
